import { Link } from "react-router-dom";
import { BRAND } from "@neus/shared";
import styles from "./Layout.module.css";

/** The brand's logo (brands/<id>/, served from /brand/). */
export function Logo({ variant = "header" }: { variant?: "header" | "footer" }) {
  const { logo } = BRAND;
  return (
    <Link
      to="/"
      className={`${styles.logo} ${variant === "footer" ? styles.logoFooter : ""}`}
      aria-label={`${BRAND.name} home`}
    >
      <img src={`/brand/${encodeURI(logo.file)}`} alt={logo.alt} width={logo.width} height={logo.height} />
    </Link>
  );
}

/** The logo on a printed sheet, top left: no link, sized by the sheet's own class. */
export function PrintLogo({ className }: { className?: string }) {
  const { logo } = BRAND;
  return (
    <img
      className={className}
      src={`/brand/${encodeURI(logo.file)}`}
      alt={logo.alt}
      width={logo.width}
      height={logo.height}
    />
  );
}
